import React from "react";

export default function Footer() {
  return (
    <footer className="px-6 py-8 border-t border-white/5">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-zinc-500">
        <p>© {new Date().getFullYear()} Josh Pascual. All rights reserved.</p>
        <a
          href="https://github.com/joshpas24/portfolio"
          target="_blank"
          rel="noreferrer"
          className="hover:text-white transition-colors flex items-center gap-2"
        >
          <i className="fa-brands fa-github"></i>
          View source
        </a>
      </div>
    </footer>
  );
}
